import { Box, HStack } from '@chakra-ui/react';
import { Logo } from '~components/ui/illustrations';
import { CONTAINER_MAX_WIDTH, CONTAINER_PADDING } from '~components/ui/PageContent';

export const NAVBAR_HEIGHT = 68;

export function Navbar() {
  return (
    <Box
      width="100%"
      height={NAVBAR_HEIGHT}
      paddingX={CONTAINER_PADDING}
      display="flex"
      maxW={CONTAINER_MAX_WIDTH}
    >
      <HStack spacing="6">
        <Logo width="50px" />
      </HStack>
    </Box>
  );
}
